import { default as _axios } from "axios";
import env from "../env";

const axios = _axios.create({
  baseURL: env.apiLink,
  timeout: 30000,
});

export default axios;
